import $ from 'jquery';
const HEADER_ID = 'header';
let header = null;

function onDocumentReady() {
	header = document.getElementById(HEADER_ID);

	if (header) {
		const mobileNavToggle = header.querySelector('.main-menu-toggle');
		if (mobileNavToggle) {
			mobileNavToggle.addEventListener('click', onClickMainMenuToggle);
		}

		const desktopSearchToggle = header.querySelector('.search-form-toggle');
		if (desktopSearchToggle) {
			desktopSearchToggle.addEventListener('click', onClickSearchToggle);
		}
	}
}

function onClickSearchToggle() {
	header.querySelector('.search-form-field').focus();
}

export function clearFocus() {
	header.querySelector('.search-form-field').blur();
}

function onClickMainMenuToggle() {
	document.body.classList.toggle('nav-open');

	if (!document.body.classList.contains('nav-open')) {
		$('.sub-menu.active', header).removeClass('active');
	}
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
